module.exports = __webpack_public_path__ + "static/google-green-abc36d78c0f94cfefd6a9a2ab057fd8e.svg";